/**
 * A reference text as the laboratory wrote it (ADR 0020): one block per line ("Hombres: …",
 * "Mujeres: …", "Niños: …"). A line that wraps hangs its continuation, so it never reads as the
 * next population; the PDF report lays it out the same way.
 */
export function RefText({ text, className = "" }: { text: string | null | undefined; className?: string }) {
  const lines = (text ?? "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);
  if (lines.length === 0) return null;
  if (lines.length === 1) return <span className={`ref-text ${className}`.trim()}>{lines[0]}</span>;
  return (
    <span className={`ref-text multi ${className}`.trim()}>
      {lines.map((l, i) => (
        <span key={i} className="ref-line">
          {l}
        </span>
      ))}
    </span>
  );
}
